import React from 'react';
import PropTypes from 'prop-types';

const isMissingAvatar = (avatarUrl) => {
  if (!avatarUrl) return true;
  return avatarUrl.includes('missing');
};

const ProfileAvatar = ({ avatarUrl, missingImgUrl }) => {
  const src = isMissingAvatar(avatarUrl) ? missingImgUrl : avatarUrl;

  return (
    <div className="profile-avatar">
      <div className="profile-avatar__frame">
        <img
          src={src}
          alt=""
          className="profile-avatar__image"
        />
      </div>
    </div>
  );
};

ProfileAvatar.propTypes = {
  avatarUrl: PropTypes.string,
  missingImgUrl: PropTypes.string.isRequired,
};

export default ProfileAvatar;
